import { createIcon } from '@chakra-ui/react'

export const Pause = createIcon({
  displayName: 'Pause',
  viewBox: '0 0 12 14',
  d: 'M0 14H4V0H0V14ZM8 0V14H12V0H8Z',
})
